import { gql, useMutation } from '@apollo/client'
import { Create, SimpleForm, useNotify, useRedirect } from 'react-admin'
import { UpsertUser } from '~/components'

// Sign-up is closed (AUTH_DISABLE_SIGNUP), so accounts are created through
// public.crm_create_user, which Hasura only exposes to admins. It hashes the
// password with bcrypt in the database.
const CREATE_USER = gql`
  mutation CreateUser($email: String!, $password: String!, $displayName: String!, $role: String!) {
    crm_create_user(
      args: { email: $email, password: $password, display_name: $displayName, default_role: $role }
    ) {
      id
    }
  }
`

const UserCreate = (props) => {
  const notify = useNotify()
  const redirect = useRedirect()
  const [createUser] = useMutation(CREATE_USER)

  const save = async ({ email, password, displayName, defaultRole }) => {
    try {
      const { data } = await createUser({
        variables: { email, password, displayName: displayName ?? '', role: defaultRole },
      })
      notify('ra.notification.created', { type: 'info', messageArgs: { smart_count: 1 } })
      redirect('edit', 'users', data.crm_create_user[0].id)
    } catch (e) {
      notify(e.message, { type: 'error' })
    }
  }

  return (
    <Create title='resources.users.create' {...props}>
      <SimpleForm onSubmit={save}>
        <UpsertUser create />
      </SimpleForm>
    </Create>
  )
}

export default UserCreate
